export const SELECT_SECTION = 'support/SELECT_SECTION'

export const GET_SECTIONS_REQUEST = 'support/GET_SECTIONS_REQUEST'
export const GET_SECTIONS_SUCCESS = 'support/GET_SECTIONS_SUCCESS'
export const GET_SECTIONS_FAILURE = 'support/GET_SECTIONS_FAILURE'

export const GET_ARTICLES_REQUEST = 'support/GET_ARTICLES_REQUEST'
export const GET_ARTICLES_SUCCESS = 'support/GET_ARTICLES_SUCCESS'
export const GET_ARTICLES_FAILURE = 'support/GET_ARTICLES_FAILURE'
